module.exports = __webpack_public_path__ + "static/media/matrix-orange.43356638.svg";